import { AudioPool } from 'utils/audio/AudioPool';
import lobbyJoinSound from 'assets/sounds/lobby-join.wav';
import * as Sentry from '@sentry/react';

export const playLobbyJoinSound = async () => {
  const audioElement = await AudioPool.obtainElement();
  if (audioElement) {
    audioElement.src = lobbyJoinSound;
    audioElement.play().catch((error) => {
      if (error instanceof DOMException && error.name === 'NotAllowedError') {
        // Autoplay policy on mobile — routine, not reportable.
        return;
      }
      Sentry.captureException(error);
    });
  }
};
